import React, { useState } from "react";
import PropTypes from "prop-types";
import { useGetUserLoginHistory } from "AppQuries/login/login";
import { format, startOfMonth, endOfMonth } from "date-fns";
import { Table, DatePicker } from "antd";
import { Link } from "react-router-dom";
import { all_routes } from "Router/all_routes";
import { BackIcon } from "Components/UI/Icon/Icons";
import Select from "react-select";
import { useTableSearch } from "core/Operations/useTableSearch";
import ReportTools from "Components/UI/ReportTools";
import dayjs from "dayjs";
import TableTop from "Components/UI/TableTop";

const { RangePicker } = DatePicker;
const typeOptions = [
  {
    id: 1,
    label: "ALL",
    value: "ALL",
  },
  {
    id: 2,
    label: "Web",
    value: "Web",
  },
  {
    id: 3,
    label: "Mobile",
    value: "Mobile",
  },
  {
    id: 4,
    label: "KioskApp",
    value: "KioskApp",
  },
];

const statusOptions = [
  {
    id: 1,
    label: "ALL",
    value: 0,
  },
  {
    id: 2,
    label: "Active",
    value: 1,
  },
  {
    id: 3,
    label: "Inactive",
    value: 2,
  },
];

const UserLoginHistory = ({ userData, userId }) => {
  const [queryParams, setQueryParams] = useState({
    companyCode: userData?.companyCode,
    userId: userId,
    type: "ALL",
    status: 0,
    fromDate: format(startOfMonth(new Date()), "yyyy-MM-dd"),
    toDate: format(endOfMonth(new Date()), "yyyy-MM-dd"),
  });
  const {
    data: loginHistoryData,
    isLoading,
    error,
    isError,
    refetch: getUserLoginHistory,
  } = useGetUserLoginHistory(queryParams);

  const [isFilterVisible, setIsFilterVisible] = useState(true);
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };

  const columns = [
    {
      title: "User ID",
      dataIndex: "userID",
    },
    {
      title: "Device ID",
      dataIndex: "deviceId",
    },
    {
      title: "Type",
      dataIndex: "type",
    },

    {
      title: "Last Login Location",
      dataIndex: "lastLoginLocation",
      // sorter: (a, b) => a.amount.length - b.amount.length,
    },
    {
      title: "Device Name",
      dataIndex: "deviceName",
      // sorter: (a, b) => a.effectiveDateFrom.length - b.effectiveDateFrom.length,
    },

    {
      title: "Login Date",
      dataIndex: "createDate",
      render: (text) => format(new Date(text), "yyyy-MM-dd HH:mm:ss"),
    },
  ];

  const searchColumns = columns.map((column, index) => column.dataIndex);
  const { searchValue, setSearchValue, filteredData } = useTableSearch(
    loginHistoryData,
    searchColumns,
  );
  const updateQueryParams = (key, value) => {
    setQueryParams((prev) => ({ ...prev, [key]: value }));
  };

  return (
    <div>
      {/* <div className="page-header">
        <div className="add-item d-flex">
          <div className="page-title">
            <h4>Allowance Management</h4>
            <h6>Manage Employee Allowance Details</h6>
          </div>
        </div>
        <div className="page-btn">
          <ReportTools
            columns={columns}
            data={filteredData}
            fileName="Employee Allowance And Deduction"
            isCSV={true}
            isPdf={true}
            pdfTheme="striped"
            // refresh={getEmpAllowance}
          />
        </div>
        <div className="page-btn">
          <Link
            to={`${all_routes.user_master}${all_routes.user_master_list}`}
            f
            className="btn btn-secondary"
          >
            <BackIcon className="me-2" />
            Back
          </Link>
        </div>
      </div> */}

      <div className="card table-list-card border-0">
        <div className="card-body">
          <TableTop
            onSearch={setSearchValue}
            toggleFilterVisibility={toggleFilterVisibility}
            isFilterVisible={isFilterVisible}
            showToggle={false}
          />
          <div
            className={`card${isFilterVisible ? " visible" : ""}`}
            id="filter_inputs"
            // style={{ display: isFilterVisible ? "block" : "none" }}
          >
            <div className="card-body pb-0">
              <div className="form-row row">
                <div className="col-lg-4 col-sm-6 col-12 mb-3">
                  <label className="form-label">Start Date – End Date</label>
                  <div className="form-group">
                    <RangePicker
                      className="form-control"
                      style={{ display: "flex" }}
                      onChange={(dates, dateStrings) => {
                        if (dates) {
                          updateQueryParams("fromDate", dateStrings[0]);
                          updateQueryParams("toDate", dateStrings[1]);
                        }
                      }}
                      defaultValue={[
                        dayjs(queryParams.fromDate, "YYYY-MM-DD"),
                        dayjs(queryParams.toDate, "YYYY-MM-DD"),
                      ]}
                      dateFormat="YYYY-MM-DD"
                      getPopupContainer={(triggerNode) =>
                        triggerNode.parentNode
                      }
                      // disabledDate={disabledDate}
                    />
                  </div>
                </div>

                {/* <div className="col-lg-2 col-sm-6 col-12 mb-3">
                  <div className="form-group">
                    <label className="form-label">Department</label>
                    <Select
                      className="select"
                      options={departmentOptions}
                      placeholder="Department"
                      value={departmentOptions.find(
                        (option) => option.value === queryParams.departmentCode,
                      )}
                      onChange={(e) => {
                        updateQueryParams("departmentCode", e?.value || 0);
                      }}
                      isClearable
                    />
                  </div>
                </div>

                <div className="col-lg-2 col-sm-6 col-12 mb-3">
                  <div className="form-group">
                    <label className="form-label">Employee</label>
                    <Select
                      className="select"
                      options={employeeOptions}
                      placeholder="Select Employee"
                      value={
                        employeeOptions.find(
                          (option) => option.value === queryParams.employeeCode,
                        ) || ""
                      }
                      onChange={(e) => {
                        updateQueryParams("employeeCode", e?.value || 0);
                      }}
                      isClearable
                    />
                  </div>
                </div> */}

                <div className="col-lg-2 col-sm-6 col-12 mb-3">
                  <div className="form-group">
                    <label className="form-label">Type</label>
                    <Select
                      className="select"
                      options={typeOptions}
                      placeholder="Logged in type"
                      value={
                        typeOptions.find(
                          (option) => option.value === queryParams.type,
                        ) || ""
                      }
                      onChange={(e) => {
                        updateQueryParams("type", e?.value || "");
                      }}
                      isClearable
                    />
                  </div>
                </div>

                <div className="col-lg-2 col-sm-6 col-12 mb-3">
                  <div className="form-group">
                    <label className="form-label">Status</label>
                    <Select
                      className="select"
                      options={statusOptions}
                      placeholder="Status"
                      value={
                        statusOptions.find(
                          (option) => option.value === queryParams.status,
                        ) || ""
                      }
                      onChange={(e) => {
                        updateQueryParams("status", e?.value || 0);
                      }}
                      isClearable
                    />
                  </div>
                </div>

                <div className="col-lg-1 col-sm-6 col-12">
                  <div className="input-blocks">
                    <label className="form-label">&nbsp;</label>
                    <Link
                      className="btn btn-filters ms-auto"
                      onClick={getUserLoginHistory}
                      type="button"
                    >
                      <i data-feather="search" className="feather-search" />
                      <>Filter</>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="table-responsive">
            <Table
              columns={columns}
              dataSource={filteredData}
              rowKey={(record) => record.key}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

const propTypes = {
  userData: PropTypes.shape({
    companyCode: PropTypes.string,
  }),
  userId: PropTypes.string.isRequired,
};

UserLoginHistory.propTypes = propTypes;

export default UserLoginHistory;
